__turbopack_context__.v({
  "addedParticipant": "L7uBEq_addedParticipant",
  "blockedBanner": "L7uBEq_blockedBanner",
  "editButton": "L7uBEq_editButton",
  "editButtonBlocked": "L7uBEq_editButtonBlocked",
  "removedParticipant": "L7uBEq_removedParticipant",
  "titleWrapper": "L7uBEq_titleWrapper",
  "warningBanner": "L7uBEq_warningBanner",
});
